import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';;
import { AbstractView } from '@core/interfaces';
import { ButtonActionPresenter } from './button-action.presenter';
import { ButtonActionViewPresenter } from './interfaces';
import { SharedModule } from '@shared/shared.module';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-button-action',
  standalone: true,
  imports: [
    SharedModule,
    ButtonModule,
  ],
  templateUrl: './button-action.component.html',
  styleUrl: './button-action.component.scss',
  providers: [ ButtonActionPresenter ]
})
export class ButtonActionComponent extends AbstractView<ButtonActionPresenter>
implements ButtonActionViewPresenter, OnInit {
  @Input() loading$!: Observable<boolean>;
  @Input() buttonCancel: boolean = true;
  @Input() buttonCreate!: boolean|undefined;
  @Input() buttonCreateCopy!: boolean|undefined;
  @Input() buttonSaveCopy!: boolean|undefined;
  @Input() buttonSave!: boolean|undefined;
  @Input() disable: boolean = false;
  @Input() saveText: string = "Save";
  @Input() buttonType: boolean = false;
  @Output() actionSaveTriggered = new EventEmitter<void>();
  @Output() actionCreateTriggered = new EventEmitter<void>();
  @Output() actionCreateCopyTriggered = new EventEmitter<void>();
  @Output() actionSaveCopyTriggered = new EventEmitter<void>();
  @Output() actionCancelTriggered = new EventEmitter<void>();

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: ButtonActionPresenter
  ) {
    super(messageService, router, store, presenter);
  }
  
  ngOnInit(): void {
    this.presenter.setView(this);
  }

  onSave(): void {
    this.actionSaveTriggered.emit();
  }

  onCreate(): void {
    this.presenter.onCreate();
  }

  onCreateCopy(): void {
    this.presenter.onCreateCopy();
  }

  onSaveCopy(): void {
    this.presenter.onSaveCopy()
  }

  onCancel(): void {
    this.presenter.onCancel();
  }
}
